import { share } from '@kk/h5-sdk';
import { deepGet } from '@kk/utils';
import toast from '@kk/toast';

import Bus, { busEvent } from '@kk-activity-factory/bus';
import globalData from '@kk-activity-factory/global-data';
import { getCurrentCommonActivityHtmlString } from '@kk-activity-factory/utils';
import { buildValidURLRandomString } from './buildValidURLRandomString';
import { screenShot } from './screenShot';
import { globalInstance } from './globalInstance';
import { transferAppUrl } from './transferAppUrl';

const { getDefaultShareScreenShot, uploadScreenShot, getScreenShot } = screenShot;

/**
 * 渠道map，后续追加就只使用字符串key，不要用数字key了
 */
const channelMap = new Map([
    [1, { name: 'Wechat', type: 1, link: '', image: '' }],
    ['Wechat', { name: 'Wechat', type: 1, link: '', image: '' }],
    [
        2,
        {
            name: 'WechatMoments',
            type: 1,
            link: '',
            image: '',
            title: '',
            desc: '',
        },
    ],
    [
        'WechatMoments',
        {
            name: 'WechatMoments',
            type: 1,
            link: '',
            image: '',
            title: '',
            desc: '',
        },
    ],
    [3, { name: 'QQ', type: 1, link: '', image: '', title: '', desc: '' }],
    ['QQ', { name: 'QQ', type: 1, link: '', image: '', title: '', desc: '' }],
    [4, { name: 'QZone', type: 1, link: '', image: '' }],
    ['QZone', { name: 'QZone', type: 1, link: '', image: '' }],
    [
        5,
        {
            name: 'SinaWeibo',
            type: 1,
            link: '',
            image: '',
            title: '',
            desc: '',
        },
    ],
    [
        'SinaWeibo',
        {
            name: 'SinaWeibo',
            type: 1,
            link: '',
            image: '',
            title: '',
            desc: '',
        },
    ],
    [
        'World',
        {
            name: 'World',
            type: 1,
            link: '',
            image: '',
            title: '',
            desc: '',
            extras: {},
        },
    ],
]);

const imgChannelMap = new Map([
    [
        1,
        {
            name: 'World',
            type: 2,
            link: '',
            image: '',
            title: '',
            desc: '',
            extras: {},
        },
    ],
    [2, { name: 'Wechat', type: 2, link: '', image: '' }],
    [
        3,
        {
            name: 'WechatMoments',
            type: 2,
            link: '',
            image: '',
            title: '',
            desc: '',
        },
    ],
    [4, { name: 'QQ', type: 2, link: '', image: '', title: '', desc: '' }],
    [5, { name: 'QZone', type: 2, link: '', image: '' }],
    [
        6,
        {
            name: 'SinaWeibo',
            type: 2,
            link: '',
            image: '',
            title: '',
            desc: '',
        },
    ],
]);

function getPlatForm({ channelList, title, desc, link, image }) {
    const platform = [];
    for (const item of channelList) {
        const channel = JSON.parse(JSON.stringify(channelMap.get(item)));

        if (channel.name === 'SinaWeibo') {
            // 微博需要拼接到platform里头的desc 否则只会有个图片没有文字内容
            channel.desc = `#快看漫画#${title}\n${desc}（来自@快看漫画）完整内容戳：`;
        }

        // 目前拉票有用到这个渠道的功能
        if (channel.name === 'World') {
            // 分享到世界（社区）渠道要单独处理一下
            // title 是后台配置的推荐语
            // desc 是投票目标 帖子名称，漫画名称
            console.info('world', title, desc);
            const pageTitle = globalInstance.getRootStore().getters.title;
            channel.desc = `${desc} ${title}`;
            channel.extras = {
                images: [],
                image_data: null,
                title: title,
                links: [
                    {
                        coverUrl: image,
                        url: transferAppUrl(link),
                        text: desc.slice(0, 20), // iOS客户端限制了20个字
                        type: 4,
                    },
                ],
                labels: [
                    {
                        name: pageTitle,
                        extras: {},
                    },
                ],
            };
            if (globalData.isAndroid) {
                // 安卓分享世界渠道要删掉这两个字段，不然闪退
                delete channel.image_data;
                delete channel.extras.image_data;
            }
        }

        platform.push(channel);
    }

    return platform;
}

async function callImgShare({ channelList, action, element, subjectId }) {
    if (!element) return;

    let image = null;
    let image_data = null;

    if (globalData.isAndroid) {
        // 安卓会因为图片大拉不起分享
        console.info('uploadScreenShot');
        image = await uploadScreenShot(element, 'graduate');
    } else {
        // 苹果用image放url的方式不知道为什么发不出去
        image_data = await getScreenShot(element, element.offsetWidth, element.offsetHeight, 7);
    }

    const platform = [];
    const param = {
        title: ' ',
        desc: ' ',
        link: ' ',
        platform,
        action,
        h5_tips: true,
        extraParams: {
            contentType: '2',
            subjectId,
            track: {},
            buttonLocation: 4,
        },
    };

    for (const item of channelList) {
        const channel = JSON.parse(JSON.stringify(imgChannelMap.get(item)));
        if (channel.name === 'World' && image_data) {
            channel.image_data = image_data;
            channel.extras = {
                image_data: image_data,
            };
        }
        platform.push(channel);
    }

    if (image_data) {
        param.image = 'placeholder'; // 非得给个值是因为h5sdk不允许为空 会出现报错 或不报错但无法唤起分享菜单
        param.image_data = image_data;
    } else {
        param.image = image;
    }

    console.info('分享参数:', param);
    share(param);
}

function defaultShareCallback(res) {
    console.info(`分享回调${JSON.stringify(res)}`);
}

// 无备注的参数详细见 https://wiki.quickcan.com/pages/viewpage.action?pageId=56591098
function callShare({
    title,
    desc,
    link,
    channelList,
    action,
    subjectId,
    image,
    image_data,
    callback,
}) {
    console.info('callShare 1');
    const param = {
        title,
        desc,
        link,
        platform: getPlatForm({ channelList, title, desc, link, image }),
        action,
        h5_tips: true,
        extraParams: {
            contentType: '2',
            subjectId,
            track: {},
            buttonLocation: 4,
        },
        callback: callback ? callback : defaultShareCallback,
    };
    console.info('callShare 2');

    if (image_data) {
        param.image = 'placeholder'; // 非得给个值是因为h5sdk不允许为空 会出现报错 或不报错但无法唤起分享菜单
        param.image_data = image_data;
    } else {
        param.image = image;
    }

    console.info('分享参数:', param);
    console.info('callShare 3');
    share(param);
    console.info('callShare 4');
}

async function buildShareParam(extraParams) {
    try {
        console.info('buildShareParam 1', JSON.stringify(extraParams));
        const image = deepGet(extraParams, 'shareImg.imgUrl', '');
        console.info('buildShareParam 2');
        let link = '';
        if (extraParams.shareType === 'link') {
            link = extraParams.link;
        } else {
            if (['staging', 'development'].includes(`${process.env.VUE_APP_HOST_ENV}`)) {
                // 测试环境小程序域名没有配置动态规则，所以测试环境用端内域名
                link = `${process.env.VUE_APP_TOPIC_HOST}/dynamic/${buildValidURLRandomString(
                    5
                )}/ads/${getCurrentCommonActivityHtmlString()}?id=${
                    window.activityEnginePageID
                }&visitsource=998`;
            } else {
                link = `${process.env.VUE_APP_MINI_HOST}/dynamic/${buildValidURLRandomString(
                    5
                )}/topic/${getCurrentCommonActivityHtmlString()}?id=${
                    window.activityEnginePageID
                }&visitsource=998`;
            }
        }
        console.info('buildShareParam 3');
        const param = {
            title: extraParams.title,
            desc: extraParams.content,
            link,
            channelList: extraParams.channelList,
            action: { type: 1 },
            subjectId: window.activityEnginePageID,
            image,
            image_data: image ? null : await getDefaultShareScreenShot(),
        };
        console.info('buildShareParam 4');
        return param;
    } catch (error) {
        console.error('buildShareParam', error);
        toast.show('无法获取分享参数，请稍后再试');
    }
}

/**
 * 这个分享会尝试完成分享任务
 * @param {*} params
 */
async function btnShare(params, finishCallBack) {
    let hasDone = false;
    callShare({
        ...(await buildShareParam(params)),
        callback: (res) => {
            console.info(`分享按钮回调${JSON.stringify(res)}`);
            if (
                res &&
                res.code === 200 &&
                res.data &&
                (res.data.path_step === 2 || res.data.path_step === 5) &&
                !hasDone
            ) {
                hasDone = true;
                finishCallBack && finishCallBack();
                Bus.$emit(busEvent.SHARE_TASK_CAN_FINISH);
            }
        },
    });
}

export const shareUtil = {
    callShare,
    buildShareParam,
    callImgShare,
    btnShare,
};
